import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AgencyDatePipe } from './agency-date.pipe';
import * as _ from 'lodash';

@Pipe({
  name: 'filterByProps',
  standalone: false
})
@Injectable()
export class FilterByPropsPipe implements PipeTransform {
  constructor(private readonly datePipe: AgencyDatePipe) {}

  transform(items: any[], searchValue: string, props: Array<string>, customDateFormat?: string): any[] {
    if (_.isUndefined(searchValue)) {
      return items.slice();
    }

    return items.slice().filter((item) => {
      return props.some((key: string) => {
        let formatedValue = item[key];

        if (_.isUndefined(formatedValue)) {
          return false;
        }

        if (formatedValue instanceof Date && customDateFormat) {
          formatedValue = this.datePipe.transform(formatedValue, false, false, customDateFormat);
        }

        const stringValue = formatedValue.toString();
        return stringValue.toLowerCase().includes(searchValue.toLowerCase());
      });
    });
  }
}
